<template>
  <div>
    <div>
      <h1>{{ $t("settings.documentTemplate.editFormTitle") }}</h1>

      <div class="mt-3 elevation-12 grey lighten-4">
        <v-card>
          <v-card-text>
            <h3>{{ $t("settings.documentTemplate.description") }}</h3>
            {{ $t("settings.documentTemplate.listOfAvailableTags") }}: <br />
            <ul>
              <li>{yyyy} - {{ $t("settings.documentTemplate.yyyy") }}</li>
              <li>{yy} - {{ $t("settings.documentTemplate.yy") }}</li>
              <li>{mm} - {{ $t("settings.documentTemplate.mm") }}</li>
              <li>{m} - {{ $t("settings.documentTemplate.m") }}</li>
              <li>{dd} - {{ $t("settings.documentTemplate.dd") }}</li>
              <li>{d} - {{ $t("settings.documentTemplate.d") }}</li>
              <li>{KRAJ/ZAGR} - {{ $t("settings.documentTemplate.krajZagr") }}</li>
              <li>
                {Krajowa/Zagraniczna} -
                {{ $t("settings.documentTemplate.krajowaZagraniczna") }}
              </li>
              <li>{numer} - {{ $t("settings.documentTemplate.number") }}</li>
              <li>{NN} - {{ $t("settings.documentTemplate.nn") }}</li>
              <li>{NNN} - {{ $t("settings.documentTemplate.nnn") }}</li>
              <li>{NNNN} - {{ $t("settings.documentTemplate.nnnn") }}</li>
            </ul>

            <v-form class="mt-3" lazy-validation ref="form" v-model="formValid">
              <v-text-field
                :label="$t('settings.documentTemplate.mask') + '*'"
                :rules="documentNumberTemplate.validateTemplateMask()"
                v-model="documentNumberTemplate.template_mask"
              ></v-text-field>
              <v-select
                :items="documentType"
                :label="$t('settings.documentTemplate.documentType') + '*'"
                :rules="documentNumberTemplate.document_type_rules"
                v-model="documentNumberTemplate.document_type"
              >
              </v-select>
              <v-select
                :items="numberType"
                :label="$t('settings.documentTemplate.numberResetType') + '*'"
                :rules="documentNumberTemplate.number_type_rules"
                v-model="documentNumberTemplate.number_type"
              >
              </v-select>
            </v-form>
          </v-card-text>
        </v-card>

        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
            <v-btn :disabled="!formValid" @click.native="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import DocumentNumberTemplate from "../../models/documentNumberTemplate";
import { documentType, numberType } from "../../staticData/DocumentNumberTemplate";

export default {
  name: "DocumentNumberTemplateForm",
  data: () => ({
    documentNumberTemplate: new DocumentNumberTemplate(),
    formValid: true
  }),
  computed: {
    documentType: documentType,
    numberType: numberType
  },
  methods: {
    save() {
      if (this.$refs.form.validate()) {
        this.documentNumberTemplate
          .save()
          .then(() => {
            this.$router.push({
              path: "/settings/system-settings/document-number-template"
            });
          })
          .catch(response => {
            this.$store.dispatch("alertDialog", {
              content: this.$t("global.error.generalError.content") + response,
              title: this.$t("global.error.generalError.title")
            });
          });
      }
    },
    cancel() {
      this.$router.back();
    }
  },
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.documentNumberTemplate.load(this.$route.params.id);
    }
  }
};
</script>

<style scoped></style>
